// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zP3AjzPE7s6pEYg_D3oA {
  position: relative;
  text-align: center
}
.jYc3VgulGjtHwczSzwHk {
  position: absolute;
  right: 0.75rem;
  cursor: pointer;
  border-color: none;
  font-size: 1.25rem;
  line-height: 1.75rem;
  background: transparent
}
.gvEliDxjuI7Lu3KsA1Uw {
  margin-top: 2.5rem;
  margin-bottom: 2.5rem;
  display: flex;
  justify-content: center;
  gap: 1rem
}
.VzlCNISibWRYkeUVDO9j {
  height: 60px;
  width: 60px;
  border-radius: 5px;
  --tw-bg-opacity: 1;
  background-color: rgb(242 242 242 / var(--tw-bg-opacity, 1));
  text-align: center;
  font-size: 1rem;
  line-height: 1.5rem;
  font-weight: 400;
  --tw-text-opacity: 1;
  color: rgb(149 149 149 / var(--tw-text-opacity, 1));
  outline: none
}
.t16xykrOH6CiS8AXaU0Q {
  text-align: center !important;
  font-family: Noto Sans;
  font-size: 20px;
  font-weight: 500
}
.Nh2yd7fbNQG7nx8Hj81q {
  margin-top: 1.5rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  row-gap: 2rem
}
.P74Re_8CPYeCogQZ_Ies {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 400;
  --tw-text-opacity: 1;
  color: rgb(141 141 141 / var(--tw-text-opacity, 1))
}
.qOduTcgPpr7Ll2y5Vg4r {
  margin: auto;
  margin-top: 0.75rem;
  margin-bottom: 1.5rem;
  display: flex;
  text-decoration-line: underline;
  text-underline-offset: 4px;
  --tw-text-opacity: 1 !important;
  color: rgb(3 120 209 / var(--tw-text-opacity, 1)) !important
}

.hfVyWEMGzRfufgDYBc5Z {
  width: 100%
}

.xpYRlX9Ti_J2i9gnjKSl {
  height: 38px;
  width: 100%
}

.nlkW4ZJbm4b4IsSMF_Ed {
  margin-top: 1rem;
  display: flex;
  justify-content: center;
  gap: 0.75rem
}

.eQtpZS280P9t6PotRIZK {
  margin-top: 1rem;
  margin-bottom: 0px;
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem
}

.kp1tDhlBzSWxO52LIYhw {
  height: 38px;
  width: 120px;
  --tw-border-opacity: 1;
  border-color: rgb(3 120 209 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  --tw-text-opacity: 1;
  color: rgb(3 120 209 / var(--tw-text-opacity, 1))
}

.kp1tDhlBzSWxO52LIYhw:hover {
  --tw-border-opacity: 1 !important;
  border-color: rgb(3 120 209 / var(--tw-border-opacity, 1)) !important;
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1)) !important;
  --tw-text-opacity: 1 !important;
  color: rgb(3 120 209 / var(--tw-text-opacity, 1)) !important
}

.Yi92CfUDhUdV58U7FPVU {
  height: 38px;
  width: 120px;
  --tw-bg-opacity: 1;
  background-color: rgb(3 120 209 / var(--tw-bg-opacity, 1));
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1))
}

.Yi92CfUDhUdV58U7FPVU:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(3 120 209 / var(--tw-bg-opacity, 1)) !important;
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important
}

._lxSJcuzK9twLECclu62 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem
}

.TZCavwUFgtXKhxApgWv5 {
  font-family: Noto Sans;
  --tw-text-opacity: 1;
  color: rgb(47 47 47 / var(--tw-text-opacity, 1))
}

.eCTsZvWyzUD_YpvtN9SH {
  text-align: right;
  font-family: Noto Sans;
  --tw-text-opacity: 1;
  color: rgb(47 47 47 / var(--tw-text-opacity, 1))
}

.YjRRwXx2lMJBI2Ka4Y6Q {
  margin-top: 1.5rem;
  display: flex;
  justify-content: center;
  gap: 1rem
}

.P3vDyFUcU3svpClizFpV {
  border-radius: 0.375rem;
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1))
}

._6z9wDj0xSWuvThcMpRo {
  border-radius: 0.375rem;
  --tw-bg-opacity: 1;
  background-color: rgb(3 120 209 / var(--tw-bg-opacity, 1));
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1))
}
._6z9wDj0xSWuvThcMpRo:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(3 120 209 / var(--tw-bg-opacity, 1)) !important;
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important
}
`, "",{"version":3,"sources":["webpack://./src/components/CustomerConsentTermsModal/CustomerConsentTermsModal.module.css"],"names":[],"mappings":"AACE;EAAA,kBAA2B;EAA3B;AAA2B;AAG3B;EAAA,kBAA4D;EAA5D,cAA4D;EAA5D,eAA4D;EAA5D,kBAA4D;EAA5D,kBAA4D;EAA5D,oBAA4D;EAC5D;AAD4D;AAI5D;EAAA,kBAAsC;EAAtC,qBAAsC;EAAtC,aAAsC;EAAtC,uBAAsC;EAAtC;AAAsC;AAGtC;EAAA,YAAmG;EAAnG,WAAmG;EAAnG,kBAAmG;EAAnG,kBAAmG;EAAnG,4DAAmG;EAAnG,kBAAmG;EAAnG,eAAmG;EAAnG,mBAAmG;EAAnG,gBAAmG;EAAnG,oBAAmG;EAAnG,mDAAmG;EACnG;AADmG;AAInG;EAAA,6BAA+D;EAA/D,sBAA+D;EAA/D,eAA+D;EAA/D;AAA+D;AAG/D;EAAA,kBAAgD;EAAhD,aAAgD;EAAhD,sBAAgD;EAAhD,uBAAgD;EAAhD;AAAgD;AAGhD;EAAA,aAAmF;EAAnF,sBAAmF;EAAnF,mBAAmF;EAAnF,uBAAmF;EAAnF,mBAAmF;EAAnF,oBAAmF;EAAnF,gBAAmF;EAAnF,oBAAmF;EAAnF;AAAmF;AAGnF;EAAA,YAAyD;EAAzD,mBAAyD;EAAzD,qBAAyD;EAAzD,aAAyD;EAAzD,+BAAyD;EAAzD,0BAAyD;EACzD,+BAAoB;EAApB;AADyD;;AAKzD;EAAA;AAAa;;AAIb;EAAA,YAAsB;EAAtB;AAAsB;;AAItB;EAAA,gBAAqC;EAArC,aAAqC;EAArC,uBAAqC;EAArC;AAAqC;;AAIrC;EAAA,gBAAuC;EAAvC,kBAAuC;EAAvC,aAAuC;EAAvC,yBAAuC;EAAvC;AAAuC;;AAIvC;EAAA,YAAwE;EAAxE,YAAwE;EAAxE,sBAAwE;EAAxE,0DAAwE;EAAxE,kBAAwE;EAAxE,4DAAwE;EAAxE,oBAAwE;EAAxE,qBAAwE;EAAxE,mBAAwE;EAAxE,sBAAwE;EAAxE,oBAAwE;EAAxE;AAAwE;;AAIxE;EAAA,iCAA8C;EAA9C,qEAA8C;EAA9C,6BAA8C;EAA9C,uEAA8C;EAA9C,+BAA8C;EAA9C;AAA8C;;AAI9C;EAAA,YAAyD;EAAzD,YAAyD;EAAzD,kBAAyD;EAAzD,0DAAyD;EAAzD,oBAAyD;EAAzD,qBAAyD;EAAzD,mBAAyD;EAAzD,sBAAyD;EAAzD,oBAAyD;EAAzD;AAAyD;;AAIzD;EAAA,6BAA8B;EAA9B,qEAA8B;EAA9B,+BAA8B;EAA9B;AAA8B;;AAI9B;EAAA,aAA6C;EAA7C,mBAA6C;EAA7C,8BAA6C;EAA7C,oBAA6C;EAA7C;AAA6C;;AAI7C;EAAA,sBAA+B;EAA/B,oBAA+B;EAA/B;AAA+B;;AAI/B;EAAA,iBAA0C;EAA1C,sBAA0C;EAA1C,oBAA0C;EAA1C;AAA0C;;AAI1C;EAAA,kBAAqC;EAArC,aAAqC;EAArC,uBAAqC;EAArC;AAAqC;;AAIrC;EAAA,uBAAiD;EAAjD,kBAAiD;EAAjD,0DAAiD;EAAjD,oBAAiD;EAAjD,qBAAiD;EAAjD,mBAAiD;EAAjD,sBAAiD;EAAjD,oBAAiD;EAAjD;AAAiD;;AAIjD;EAAA,uBAAiD;EAAjD,kBAAiD;EAAjD,0DAAiD;EAAjD,oBAAiD;EAAjD,qBAAiD;EAAjD,mBAAiD;EAAjD,sBAAiD;EAAjD,oBAAiD;EAAjD;AAAiD;AAGjD;EAAA,6BAA8B;EAA9B,qEAA8B;EAA9B,+BAA8B;EAA9B;AAA8B","sourcesContent":[".otpModal {\n  @apply relative text-center;\n}\n.closeBtn {\n  @apply absolute text-xl cursor-pointer border-[none] right-3;\n  background: transparent;\n}\n.otpWrapper {\n  @apply flex justify-center gap-4 my-10;\n}\n.otpInput {\n  @apply w-[60px] h-[60px] text-center text-base font-normal text-[#959595] rounded-[5px] bg-otpInput;\n  outline: none;\n}\n.header {\n  @apply text-subtitle font-dashboardMain !text-center font-inter;\n}\n.modalContainer {\n  @apply flex flex-col justify-center gap-y-8 mt-6;\n}\n.infoContainer {\n  @apply flex flex-col justify-center items-center text-[#8D8D8D] font-normal text-sm;\n}\n.resendButton {\n  @apply underline underline-offset-4 flex mt-3 mb-6 m-auto;\n  @apply !text-primary;\n}\n\n.branchFilter {\n  @apply w-full;\n}\n\n.creationFilter {\n  @apply w-full h-[38px];\n}\n\n.button {\n  @apply flex justify-center gap-3 mt-4;\n}\n\n.buttonRight {\n  @apply flex justify-end gap-3 mt-4 mb-0;\n}\n\n.clearButton {\n  @apply bg-white text-primary border-primary px-6 py-2 w-[120px] h-[38px];\n}\n\n.clearButton:hover {\n  @apply !bg-white !text-primary !border-primary;\n}\n\n.applyButton {\n  @apply bg-primary text-white px-6 py-2 w-[120px] h-[38px];\n}\n\n.applyButton:hover {\n  @apply !bg-primary !text-white;\n}\n\n.rowItem {\n  @apply flex justify-between items-center py-1;\n}\n\n.keyText {\n  @apply text-gray-500 font-inter;\n}\n\n.valueText {\n  @apply text-gray-500 font-inter text-right;\n}\n\n.buttonCenter {\n  @apply flex justify-center gap-4 mt-6;\n}\n\n.rejectButton {\n  @apply bg-red-600 text-white px-6 py-2 rounded-md;\n}\n\n.acceptButton {\n  @apply bg-primary text-white px-6 py-2 rounded-md;\n}\n.acceptButton:hover {\n  @apply !bg-primary !text-white;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"otpModal": `zP3AjzPE7s6pEYg_D3oA`,
	"closeBtn": `jYc3VgulGjtHwczSzwHk`,
	"otpWrapper": `gvEliDxjuI7Lu3KsA1Uw`,
	"otpInput": `VzlCNISibWRYkeUVDO9j`,
	"header": `t16xykrOH6CiS8AXaU0Q`,
	"modalContainer": `Nh2yd7fbNQG7nx8Hj81q`,
	"infoContainer": `P74Re_8CPYeCogQZ_Ies`,
	"resendButton": `qOduTcgPpr7Ll2y5Vg4r`,
	"branchFilter": `hfVyWEMGzRfufgDYBc5Z`,
	"creationFilter": `xpYRlX9Ti_J2i9gnjKSl`,
	"button": `nlkW4ZJbm4b4IsSMF_Ed`,
	"buttonRight": `eQtpZS280P9t6PotRIZK`,
	"clearButton": `kp1tDhlBzSWxO52LIYhw`,
	"applyButton": `Yi92CfUDhUdV58U7FPVU`,
	"rowItem": `_lxSJcuzK9twLECclu62`,
	"keyText": `TZCavwUFgtXKhxApgWv5`,
	"valueText": `eCTsZvWyzUD_YpvtN9SH`,
	"buttonCenter": `YjRRwXx2lMJBI2Ka4Y6Q`,
	"rejectButton": `P3vDyFUcU3svpClizFpV`,
	"acceptButton": `_6z9wDj0xSWuvThcMpRo`
};
export default ___CSS_LOADER_EXPORT___;
